import React, { useState } from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import Switch from "react-switch";


export const CustomSwitch = ({
    checked,
    handleChange,
    labelText

}) => {
    return (
        <div className="">
            {/* {labelText && <span style={{textTransform: "capitalize"}}>{labelText}</span>} */}
            <Switch onChange={handleChange} checked={checked} checkedIcon={false} uncheckedIcon={false} onColor='#1AD598' offColor='#EF4844'
                width={45}
                height={22}
                
            />
        </div>
    )
}
